import React from "react"
import HeadingSkeleton from "../../../components/skeletons/HeadingSkeleton";
import AvatarSkeleton from "../../../components/skeletons/AvatarSkeleton";

export default function ClientListSkeleton({close, getListing, setGetListing, id}) {
    return(
        <div
            className="main_div_listing mb-3 pb-3 pt-3"
        >
            <div className="inner_div_comp">
                <div
                    className="header"
                    style={{
                        borderBottom: "1px solid #353535",
                        paddingBottom: "15px",
                    }}
                >
                    <div className="Profile">
                        <div className="img_div">
                            <AvatarSkeleton height={50} width={50}/>
                        </div>
                        <div className="name_section">
                            <p><HeadingSkeleton height={10} maxWidth={100} /></p>
                            <p className="para"><HeadingSkeleton height={10} maxWidth={100} /></p>
                        </div>
                    </div>
                    <div className="date_time_main_div">
                        <div className="inner_div_date">
                            <p className="aplha_date"><HeadingSkeleton height={10} maxWidth={100} /></p>
                            <div className="inner_time_div">
                                <p><HeadingSkeleton height={10} maxWidth={100} /></p>
                                <p><HeadingSkeleton height={10} maxWidth={100} /></p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="event_section">
                    <div className="birthday_div">
                        <p><HeadingSkeleton height={10} maxWidth={100} /> <HeadingSkeleton height={10} maxWidth={100} /></p>
                    </div>
                    <div className="birthday_div">
                        <p><HeadingSkeleton height={10} maxWidth={100} /> <HeadingSkeleton height={10} maxWidth={100} /></p>
                    </div>
                </div>
            </div>
        </div>
    )
}